import { render, staticRenderFns } from "./ReportShutdown.vue?vue&type=template&id=9ad70cd2&scoped=true&"
import script from "./ReportShutdown.vue?vue&type=script&lang=js&"
export * from "./ReportShutdown.vue?vue&type=script&lang=js&"
import style0 from "./ReportShutdown.vue?vue&type=style&index=0&id=9ad70cd2&prod&lang=css&"
import style1 from "./ReportShutdown.vue?vue&type=style&index=1&id=9ad70cd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ad70cd2",
  null
  
)

export default component.exports